export default {
      id: "oc-res-ssl-certificate-usage",
      viewBox: "0 0 1024 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-res-ssl-certificate",
      toString: function () {
        return this.url;
      }
    }